import {post, get, downloadFile} from './Tools';

const procesarNomina = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}procesar_nomina`, payload);
  return response;
};

const obtenerReporte = async (period_id, anio, num_periodo, conceptos = null) => {
  let url = `${process.env.REACT_APP_SERVER}procesar_nomina/reporte/${period_id}/${anio}/${num_periodo}`;
  if (Array.isArray(conceptos) && conceptos.length > 0) {
    url += `?conceptos=${encodeURIComponent(conceptos.join(','))}`;
  }
  const response = await downloadFile(url, `${period_id}-${anio}-${num_periodo}.xlsx`);
  return response;
};

const conceptosReporte = async (period_id, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}procesar_nomina/conceptos-reporte/${period_id}/${anio}/${num_periodo}`);
  return response;
};

const obtenerReporteDebug = async (period_id, anio, num_periodo) => {
  const response = await downloadFile(`${process.env.REACT_APP_SERVER}procesar_nomina/debug/reporte/${period_id}/${anio}/${num_periodo}`, `DebugNomina-${period_id}-${anio}-${num_periodo}.xlsx`);
  return response;
};


const procesarNominaEmpleado = async (payload) => {
    const response = await post(`${process.env.REACT_APP_SERVER}procesar_nomina/empleado`, payload);
    return response;
};

const cerrarNomina = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}procesar_nomina/cerrar`, payload);
  return response;
};

const desafectarNomina = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}procesar_nomina/desafectar`, payload);
  return response;
};

const bitacoraProcesoNomina = async (period_id, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}bitacora_proceso_nomina/${period_id}/${anio}/${num_periodo}`);
  return response;
};

const recibosEncabezadoNomina = async (period_id, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}recibo_nomina/${period_id}/${anio}/${num_periodo}`);
  return response;
};

const reciboDetalleNomina = async (odoo_empleado_id, period_id, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}recibo_nomina/${odoo_empleado_id}/${period_id}/${anio}/${num_periodo}`);
  return response;
};

const obtenerTotales = async (period_id, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}recibo_nomina/get/totales/${period_id}/${anio}/${num_periodo}`);
  return response;
};

const obtenerProcesoNomina = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}procesar_nomina/empleado`, payload);
  return response;
};

const obtenerAcumuladosEmpleado = async (empleadoId, anio) => {
  const response = await get(`${process.env.REACT_APP_SERVER}procesar_nomina/acumulados/${empleadoId}/${anio}`);
  return response;
};

const regenerarAcumulados = async (empleadosIds, anio) => {
  const response = await post(`${process.env.REACT_APP_SERVER}procesar_nomina/regenerar-acumulados`, {
    empleados_ids: empleadosIds,
    anio: anio
  });
  return response;
};

const obtenerEmpleadosConRecibos = async (anio) => {
  const response = await get(`${process.env.REACT_APP_SERVER}procesar_nomina/empleados-con-recibos/${anio}`);
  return response;
};

export { obtenerReporte, conceptosReporte, obtenerReporteDebug, obtenerTotales, cerrarNomina, desafectarNomina, procesarNomina, procesarNominaEmpleado, recibosEncabezadoNomina, reciboDetalleNomina, bitacoraProcesoNomina, obtenerAcumuladosEmpleado, regenerarAcumulados, obtenerEmpleadosConRecibos};
